import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const AlertsPanel = ({ alerts }) => {
  const getAlertIcon = (type) => {
    switch (type) {
      case 'restricted_card':
        return 'AlertTriangle';
      case 'billing_issue':
        return 'CreditCard';
      case 'system_alert':
        return 'Bell';
      case 'security_alert':
        return 'Shield';
      default:
        return 'Info';
    }
  };

  const getAlertColor = (type, priority) => {
    if (priority === 'high') return 'text-error';
    if (priority === 'medium') return 'text-warning';
    return 'text-text-muted';
  };

  const getAlertBgColor = (type, priority) => {
    if (priority === 'high') return 'bg-error/10 border-error/20';
    if (priority === 'medium') return 'bg-warning/10 border-warning/20';
    return 'bg-surface border-border';
  };

  const handleAlertAction = (alert) => {
    switch (alert.type) {
      case 'restricted_card':
        window.location.href = '/card-management';
        break;
      case 'billing_issue':
        window.location.href = '/billing-management';
        break;
      default:
        break;
    }
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-text-primary">Alerts</h3>
        <div className="flex items-center space-x-2">
          <span className="text-xs text-text-muted">
            {alerts.filter(a => a.priority === 'high').length} urgent
          </span>
          <Button variant="ghost" iconName="Settings" className="p-1" />
        </div>
      </div>

      <div className="space-y-3 max-h-80 overflow-y-auto">
        {alerts.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={32} className="text-success mx-auto mb-2" />
            <p className="text-text-muted">No active alerts</p>
          </div>
        ) : (
          alerts.map((alert, index) => (
            <div
              key={index}
              className={`p-3 rounded-lg border ${getAlertBgColor(alert.type, alert.priority)}`}
            >
              <div className="flex items-start space-x-3">
                <Icon
                  name={getAlertIcon(alert.type)}
                  size={16}
                  className={`flex-shrink-0 mt-0.5 ${getAlertColor(alert.type, alert.priority)}`}
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between mb-1">
                    <h4 className="text-sm font-medium text-text-primary">
                      {alert.title}
                    </h4>
                    <span className={`text-xs px-2 py-1 rounded-full ${
                      alert.priority === 'high' ?'bg-error/20 text-error' 
                        : alert.priority === 'medium' ?'bg-warning/20 text-warning' :'bg-text-muted/20 text-text-muted'
                    }`}>
                      {alert.priority}
                    </span>
                  </div>
                  <p className="text-xs text-text-muted mb-2">
                    {alert.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-text-muted">
                      {new Date(alert.timestamp).toLocaleString()}
                    </span>
                    {alert.actionable && (
                      <Button
                        variant="ghost"
                        onClick={() => handleAlertAction(alert)}
                        className="text-xs p-1 h-auto"
                      >
                        Resolve
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AlertsPanel;